import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const CollectionButton = ({ image, heading, href, active }) => {
  return (
    <div className='flex flex-col gap-5'>
      <div className={clsx('w-full aspect-video relative overflow-hidden rounded-lg group', active && 'ring-2 ring-primary-500')}>
        <Link href={href}>
          <a className='absolute inset-0 z-10'>
            <div className='absolute inset-0 z-20 bg-gray-900 bg-opacity-90 group-hover:bg-opacity-75 transition duration-300 '></div>
            <Image layout='fill' src={image} alt={heading} className='absolute inset-0 z-10 object-cover w-full h-full' />
            <div className='absolute inset-0 z-30 text-center w-full h-full flex items-center justify-center flex-col'>
              <h3 className='font-bold text-xl xl:text-md 2xl:text-xl w-full px-8 2xl:px-0'>{heading}</h3>
            </div>
          </a>
        </Link>
      </div>
    </div>
  );
};

export default CollectionButton;
